import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
let NotificationModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec7 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec8 = attr('string'), _dec9 = attr('boolean'), _dec0 = attr('boolean', {
  defaultValue: false
}), _class = class NotificationModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "date", _descriptor, this);
    _initializerDefineProperty(this, "from_id", _descriptor2, this);
    _initializerDefineProperty(this, "from_name", _descriptor3, this);
    _initializerDefineProperty(this, "model_name", _descriptor4, this);
    _initializerDefineProperty(this, "model_id", _descriptor5, this);
    _initializerDefineProperty(this, "to", _descriptor6, this);
    _initializerDefineProperty(this, "contacts", _descriptor7, this);
    _initializerDefineProperty(this, "notification", _descriptor8, this);
    _initializerDefineProperty(this, "read", _descriptor9, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor0, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "date", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "from_id", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "from_name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "model_name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "model_id", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "to", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "notification", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "read", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { NotificationModel as default };
//# sourceMappingURL=notification.js.map
